import React, { Component } from "react";
import "../../css/AiRpCommonAssets.css";
import "../../css/AiRpInstalling.css";

import TitleContentDialogV2 from '../modules/dialogs/TitleContentDialogV2';
import BasicDialogV2 from '../modules/dialogs/BasicDialogV2';
import WarningDialog from '../modules/dialogs/WarningDialog';

import * as TargetViewUtil from '../targetView/TargetViewUtil'; // 타겟뷰 유틸

import { http } from "../modules/api";

let func_title_content_dialog;

class AiRpInstalling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settingList: [],
      targetviewInstallYn: props.targetviewInstallYn || "N",
    };
  }
  componentDidMount() {
    this.setState({
      targetviewInstallYn: this.props.targetviewInstallYn || "N",
    });
    this.fetchSettingList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.targetviewInstallYn !== this.props.targetviewInstallYn) {
      this.setState({
        targetviewInstallYn: this.props.targetviewInstallYn || "N",
      });
    }
  }

  /**
   * 페이지 목록 조회
   */
  fetchSettingList = () => {
    http.get("/rest/shop/ai/rp/settingListByPageId", {
      params: {}
    })
    .then(res => {
      // 서버가 Map으로 내려준 구조 그대로 저장
      this.setState({
        settingList: res.data.setting_list ? res.data.setting_list : [],
      });
    })
    .catch(err => {
      this.setState({ loading: false, sync: false });
      alert("페이지 목록 조회 에러");
    });
  };

  insertProductDetailDurationScriptTag() {
      let data = {
      };
      const config = {
          headers: {
              'content-type': 'application/json;',
          },
      };
      http
      .post('/rest/shop/cafe24/insertProductDetailDurationScriptTag', data, config)
      .then((res) => {
          const { data } = res;
          if (data.code == "0000") {
              this.basicDialog(true,"타겟뷰 스크립트 설치가 완료되었습니다.");
          } else if (data.code == "9004") {	// 9004 : 해당 서비스 유형의 Cafe24 App이 미설치 상태 입니다.
            this.titleContentDialog(true
              ,`<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 0.5C16.1433 0.5 12.3731 1.64366 9.16639 3.78634C5.95963 5.92903 3.46027 8.97451 1.98436 12.5377C0.508449 16.1008 0.122284 20.0216 0.874696 23.8043C1.62711 27.5869 3.4843 31.0615 6.21143 33.7886C8.93855 36.5157 12.4131 38.3729 16.1957 39.1253C19.9784 39.8777 23.8992 39.4916 27.4623 38.0156C31.0255 36.5397 34.071 34.0404 36.2137 30.8336C38.3564 27.6269 39.5 23.8567 39.5 20C39.495 14.8298 37.439 9.87278 33.7831 6.2169C30.1272 2.56102 25.1702 0.504964 20 0.5ZM18.5 11C18.5 10.6022 18.658 10.2206 18.9393 9.93934C19.2207 9.65804 19.6022 9.5 20 9.5C20.3978 9.5 20.7794 9.65804 21.0607 9.93934C21.342 10.2206 21.5 10.6022 21.5 11V21.5C21.5 21.8978 21.342 22.2794 21.0607 22.5607C20.7794 22.842 20.3978 23 20 23C19.6022 23 19.2207 22.842 18.9393 22.5607C18.658 22.2794 18.5 21.8978 18.5 21.5V11ZM20 30.5C19.555 30.5 19.12 30.368 18.75 30.1208C18.38 29.8736 18.0916 29.5222 17.9213 29.111C17.751 28.6999 17.7064 28.2475 17.7932 27.811C17.8801 27.3746 18.0944 26.9737 18.409 26.659C18.7237 26.3443 19.1246 26.13 19.5611 26.0432C19.9975 25.9564 20.4499 26.001 20.861 26.1713C21.2722 26.3416 21.6236 26.63 21.8708 27C22.118 27.37 22.25 27.805 22.25 28.25C22.25 28.8467 22.013 29.419 21.591 29.841C21.169 30.2629 20.5967 30.5 20 30.5Z" fill="#ACACAC"></path></svg>`
              , "Cafe24 타겟뷰 App이 미설치 상태 입니다.<br/>설치 하시겠습니까?");
              func_title_content_dialog = () => {window.open("https://store.cafe24.com/kr/apps/22839", "_blank")};
          } else if (data.code == "422") {	// 422 : 해당 shop과 screen path에 이미 설치된 스크립트가 존재합니다. (카페24 리턴)
            this.warningDialog(true,"이미 설치된 스크립트가 존재합니다.");
          } else if (data.code == "-999") {	// -999 : 해당 shop과 screen path에 이미 설치된 스크립트가 존재합니다. (내부 리턴)
            this.warningDialog(true,"이미 설치된 스크립트가 존재합니다.");
          } else {
              alert(
                  '[code : ' +
                  data.code +
                  ']' +
                  '\n관리자에게 문의해 주세요. (1599-3518)',
              );
          }
          this.targetViewInstallPopupCafe24(false); // 팝업 닫기
          // this.targetViewInstallYn(); // 타겟뷰 설치 여부 재조회
          window.location.reload(); // 새로고침하여 설치 상태 반영
      })
      .catch((error) => {
          alert('설치 요청 실패' + '\n관리자에게 문의해 주세요. (1599-3518)');
      }); 
    }

    targetViewInstallPopupCafe24(state) {
    if (state) {
      if (this.state.solution_type_cd == null) {
        this.titleContentDialog(true
          ,`<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 0.5C16.1433 0.5 12.3731 1.64366 9.16639 3.78634C5.95963 5.92903 3.46027 8.97451 1.98436 12.5377C0.508449 16.1008 0.122284 20.0216 0.874696 23.8043C1.62711 27.5869 3.4843 31.0615 6.21143 33.7886C8.93855 36.5157 12.4131 38.3729 16.1957 39.1253C19.9784 39.8777 23.8992 39.4916 27.4623 38.0156C31.0255 36.5397 34.071 34.0404 36.2137 30.8336C38.3564 27.6269 39.5 23.8567 39.5 20C39.495 14.8298 37.439 9.87278 33.7831 6.2169C30.1272 2.56102 25.1702 0.504964 20 0.5ZM18.5 11C18.5 10.6022 18.658 10.2206 18.9393 9.93934C19.2207 9.65804 19.6022 9.5 20 9.5C20.3978 9.5 20.7794 9.65804 21.0607 9.93934C21.342 10.2206 21.5 10.6022 21.5 11V21.5C21.5 21.8978 21.342 22.2794 21.0607 22.5607C20.7794 22.842 20.3978 23 20 23C19.6022 23 19.2207 22.842 18.9393 22.5607C18.658 22.2794 18.5 21.8978 18.5 21.5V11ZM20 30.5C19.555 30.5 19.12 30.368 18.75 30.1208C18.38 29.8736 18.0916 29.5222 17.9213 29.111C17.751 28.6999 17.7064 28.2475 17.7932 27.811C17.8801 27.3746 18.0944 26.9737 18.409 26.659C18.7237 26.3443 19.1246 26.13 19.5611 26.0432C19.9975 25.9564 20.4499 26.001 20.861 26.1713C21.2722 26.3416 21.6236 26.63 21.8708 27C22.118 27.37 22.25 27.805 22.25 28.25C22.25 28.8467 22.013 29.419 21.591 29.841C21.169 30.2629 20.5967 30.5 20 30.5Z" fill="#ACACAC"></path></svg>`
          , this.state.solution_type_cd == "09001" 
              ? "<p>타겟뷰 서비스 미신청 상태입니다.<br/>타겟뷰 서비스 신청을 하시겠습니까?</p><p>카페24 타겟뷰 앱이 설치되어 있는 경우<br/>타겟뷰 스크립트도 같이 설치됩니다.</p>"
              : "<p>타겟뷰 서비스 미신청 상태입니다.<br/>타겟뷰 서비스 신청을 하시겠습니까?</p>"
          );
          func_title_content_dialog = TargetViewUtil.onClickShopActiveServiceButton;
        return false;
      }
    }

    if (document.querySelector('.mobile_side')?.classList.contains('active')) {
      this.mobileMenuCloseClick();
    }
    this.setState({
      is_open_target_view_install_popup_cafe24 : state,
    })
  }

  basicDialog(state, content) {
    this.setState({
      is_open_basic_dialog : state,
      basic_dialog_content : content,
    })
  }
  
  warningDialog(state, content) {
    this.setState({
      is_open_warning_dialog : state,
      warning_dialog_content : content,
    })
  }
  
  titleContentDialog(state, title, content, is_confirm) {
    this.setState({
      is_open_title_content_dialog : state,
      title_content_dialog_title : title,
      title_content_dialog_content : content,
    });
    if (is_confirm && func_title_content_dialog) {
      func_title_content_dialog(); // 기눙 실행
      func_title_content_dialog = null; // 기능 초기화 
    }
  }

  render() {
    const { settingList, targetviewInstallYn } = this.state;

    const is_robomd_ai_main_page_use = settingList.some(
      slot => slot.iframe_page_id === "robomd_ai_main_page"
    );
    const is_robomd_ai_cart_page_use = settingList.some(
      slot => slot.iframe_page_id === "robomd_ai_cart_page"
    );
    const is_robomd_ai_order_complete_page_use = settingList.some(
      slot => slot.iframe_page_id === "robomd_ai_order_complete_page"
    );
    const is_robomd_ai_detail_page_use = settingList.some(
      slot => slot.iframe_page_id === "robomd_ai_detail_page"
    );

    return (
      <>
       <div id='common-page-wrapper'>
        <div className="ai-rp-installing">
          <div className="layout-wrapper">
            <main className="main-content">
              <div className="container">
                <div className="page-header">
                  <h1>
                    환영합니다! 매출을 올리는 AI, RoboMD 입니다.
                  </h1>
                  <p>
                    가입이 완료되었습니다. 쇼핑몰회원과 비회원의 체류활동까지 수집되는 AI 추천을 적용하여 2주간 무료로 성과를 확인해보세요.
                  </p>
                </div>
                <section className="card metrics-card">
                  <div className="metrics-header">
                    <h2>
                      이미 많은 기업들이 RoboMD로 성과를 내고 있습니다.
                    </h2>
                    <p>
                      RoboMD 도입 쇼핑몰들의 평균적인 AI 추천 성과입니다.
                    </p>
                  </div>
                  <div className="metrics-grid">
                    <div className="metric-item">
                      <p className="metric-label">
                        추천 페이지뷰
                      </p>
                      <p className="metric-value num-font">
                        148,359
                        <span className="metric-unit">
                          뷰
                        </span>
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        추천 실 노출수
                      </p>
                      <p className="metric-value num-font">
                        43,403
                        <span className="metric-unit">
                          건
                        </span>
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        추천 클릭수
                      </p>
                      <p className="metric-value num-font">
                        344
                        <span className="metric-unit">
                          건
                        </span>
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        추천 구매건수
                      </p>
                      <p className="metric-value num-font">
                        58
                        <span className="metric-unit">
                          건
                        </span>
                      </p>
                    </div>
                    <div className="metric-item">
                      <p className="metric-label">
                        추천 기여 매출
                      </p>
                      <p className="metric-value highlight num-font">
                        ₩ 9,571,708
                      </p>
                    </div>
                  </div>
                </section>
                <section className={"card status-banner" + (targetviewInstallYn === "Y" ? "" : " non-installed")}>
                  <div className="status-left">
                    {
                      targetviewInstallYn === "Y" ? (
                        <>
                          <div className="radar-box">
                            <div className="radar-wave"></div>
                            <i className="fa-solid fa-satellite-dish"></i>
                          </div>
                          <div className="status-text">
                            <h2>
                              AI타겟뷰 연동 완료 — 방문자 활동 수집 중
                              <span className="badge-success">
                                설치 완료
                              </span>
                            </h2>
                            <p>
                              방문자의 상품 클릭, 체류시간, 관심 카테고리, 재방문 여부 등을 분석해
                              <strong style={{marginLeft: "4px"}}>
                                AI추천의 비회원 추천 정확도 향상에 사용됩니다.
                              </strong>
                            </p>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="status-icon-wrapper">
                            <div className="pulse-bg"></div>
                            <i className="fa-solid fa-download"></i>
                          </div>
                          <div className="status-text">
                            <h2>
                              AI타겟뷰 앱 설치가 완료되었습니다. 이제 방문 행동 분석 스크립트를 설치해볼까요?
                              <span className="badge-essential">
                                설치 대기 중
                              </span>
                            </h2>
                            <p>
                              방문자의 상품 클릭, 체류시간, 관심 카테고리, 재방문 여부 등을 분석해
                              <strong style={{marginLeft: "4px"}}>
                                AI추천의 비회원 추천 정확도 향상에 사용됩니다.
                              </strong>
                            </p>
                          </div>
                        </>
                      )
                    }
                  </div>
                  {
                    targetviewInstallYn === "Y" ? (
                      <div className="status-right">
                        <div className="live-badge">
                          <div className="live-dot"></div>
                          실시간 수집 중
                        </div>
                      </div>
                    ) : (
                      <div className="status-right">
                        <button className="btn-action-target" onClick={ () => { this.insertProductDetailDurationScriptTag()} }>
                          <i className="fa-brands fa-app-store-ios"></i>
                          AI타겟뷰 스크립트 무료 설치하기
                        </button>
                      </div>
                    )
                  }
                </section>
                <section>
                  <h2 className="section-title">
                    단 한 번의 설치로 경험하는 영역별 AI 추천 성과
                  </h2>
                  <div className="widget-grid">
                    <div className="widget-card">
                      <div>
                        <div className="w-icon w-icon-1">
                          <i className="fa-regular fa-file-lines"></i>
                        </div>
                        <h3 className="w-title">
                          상품 상세 (Item-Based CF)
                        </h3>
                        <p className="w-desc">
                          "이 상품을 본 고객이 함께 산 상품"을 딥러닝으로 매칭하여 추가 구매를 유도합니다.
                        </p>
                      </div>
                      <div className="w-footer">
                        <div className="w-effect">
                          <span className="e-label">
                            예상 추천 구매 전환율
                          </span>
                          <span className="e-val num-font">
                            30.00%
                          </span>
                        </div>
                        {
                          is_robomd_ai_detail_page_use
                          ? <button className="btn-install" disabled>
                            <i className="fa-solid fa-spinner fa-spin"></i>
                            설치 진행 중
                          </button>
                          : <button className="btn-install">
                            설치요청
                          </button>
                        }
                      </div>
                    </div>
                    <div className="widget-card">
                      <div>
                        <div className="w-icon w-icon-2">
                          <i className="fa-solid fa-cart-shopping"></i>
                        </div>
                        <h3 className="w-title">
                          장바구니 (Cross-Sell)
                        </h3>
                        <p className="w-desc">
                          장바구니 상품과 연관성이 높은 아이템을 제안하여 동시 구매율을 높입니다.
                        </p>
                      </div>
                      <div className="w-footer">
                        <div className="w-effect">
                          <span className="e-label">
                            예상 추천 구매 전환율
                          </span>
                          <span className="e-val num-font">
                            40.48%
                          </span>
                        </div>
                        {
                          is_robomd_ai_cart_page_use
                          ? <button className="btn-install" disabled>
                            <i className="fa-solid fa-spinner fa-spin"></i>
                            설치 진행 중
                          </button>
                          : <button className="btn-install">
                            설치요청
                          </button>
                        }
                      </div>
                    </div>
                    <div className="widget-card">
                      <div>
                        <div className="w-icon w-icon-3">
                          <i className="fa-solid fa-circle-check"></i>
                        </div>
                        <h3 className="w-title">
                          구매완료 (재구매 유도)
                        </h3>
                        <p className="w-desc">
                          결제 직후 고객의 취향을 분석해 다음 방문 시 구매할 가능성이 높은 상품을 노출합니다.
                        </p>
                      </div>
                      <div className="w-footer">
                        <div className="w-effect">
                          <span className="e-label">
                            예상 추천 구매 전환율
                          </span>
                          <span className="e-val num-font">
                            15.20%
                          </span>
                        </div>
                        {
                          is_robomd_ai_order_complete_page_use
                          ? <button className="btn-install" disabled>
                            <i className="fa-solid fa-spinner fa-spin"></i>
                            설치 진행 중
                          </button>
                          : <button className="btn-install">
                            설치요청
                          </button>
                        }
                      </div>
                    </div>
                    <div className="widget-card">
                      <div>
                        <div className="w-icon w-icon-4">
                          <i className="fa-solid fa-house"></i>
                        </div>
                        <h3 className="w-title">
                          메인 홈 (Best Seller)
                        </h3>
                        <p className="w-desc">
                          방문자의 관심 키워드와 연관된 상품을 분석하여 가장 구매 확률이 높은 상품을 보여줍니다.
                        </p>
                      </div>
                      <div className="w-footer">
                        <div className="w-effect">
                          <span className="e-label">
                            예상 추천 구매 전환율
                          </span>
                          <span className="e-val num-font">
                            9.76%
                          </span>
                        </div>
                        {
                          is_robomd_ai_main_page_use
                          ? <button className="btn-install" disabled>
                            <i className="fa-solid fa-spinner fa-spin"></i>
                            설치 진행 중
                          </button>
                          : <button className="btn-install">
                            설치요청
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                </section>
                <section className="card onboarding-card">
                  <div className="step-container">
                    <div className="step-line"></div>
                    <div className="step-line-active" style={{"width": "40%"}}></div>
                    <div className="step-item active">
                      <div className="step-circle">
                        <i className="fa-solid fa-check"></i>
                      </div>
                      <div className="step-name">
                        회원 가입
                      </div>
                    </div>
                    <div className="step-item active">
                      <div className="step-circle">
                        <i className="fa-solid fa-check"></i>
                      </div>
                      <div className="step-name">
                        AI타겟뷰 앱 설치
                      </div>
                    </div>
                    <div className="step-item current">
                      <div className="step-circle num-font">
                        3
                      </div>
                      <div className="step-name">
                        AI 추천 설치 중
                      </div>
                    </div>
                    <div className="step-item">
                      <div className="step-circle num-font">
                        4
                      </div>
                      <div className="step-name">
                        무료 체험 (2주)
                      </div>
                    </div>
                    <div className="step-item">
                      <div className="step-circle num-font">
                        5
                      </div>
                      <div className="step-name">
                        도입 결정
                      </div>
                    </div>
                  </div>
                  <div className="action-area">
                    <button className="btn-action-install" disabled>
                      <i className="fa-solid fa-spinner fa-spin"></i>
                      AI 추천 엔진 설치 진행 중...
                    </button>
                    <p className="helper-text">
                      설치 요청이 완료되었습니다! 개발팀에서 고객님의 쇼핑몰 환경에 맞춰 추천 엔진을 설치하고 있습니다.
                      <br />
                      <strong style={{"color": "var(--deep-navy)"}}>
                        설치가 완료되면 자동으로 [무료 체험] 단계로 전환
                      </strong>
                      되어 라이브 데이터를 확인하실 수 있습니다.
                    </p>
                  </div>
                </section>
              </div>
            </main>
          </div>
        </div>
       </div>
       {
          this.state.is_open_title_content_dialog
          ? <TitleContentDialogV2
              title={this.state.title_content_dialog_title}
              content={this.state.title_content_dialog_content}
              button_list={[{
                  title : "예",
                  event_method : () => { this.titleContentDialog(false, "", "", true)}
              },{
                  title : "아니요",
                  event_method : () => {this.titleContentDialog(false, "", "")}
              }]}
              popup_close={() => this.titleContentDialog(false, "", "")}
            />
          : ""  
        }  
        {
          this.state.is_open_basic_dialog
          ? <BasicDialogV2
            content={this.state.basic_dialog_content}
            button_list={[{
                title : "확인",
                event_method : () => { this.basicDialog(false,"") }
            }]}
          />
          : ""
        }
        {
          this.state.is_open_warning_dialog
          ? <WarningDialog
                content={this.state.warning_dialog_content}
                button_list={[{
                    title : "확인",
                    event_method : () => { this.warningDialog(false,"") }
                }]}
                popup_close={() => this.warningDialog(false,"")}
            />
          : ""       
        }
        </>
    );
  }
}

export default AiRpInstalling;
